// Module
var code = `<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.transactionForm">
  <table class="misc-transaction__table table">
    <tbody>
    <tr>
      <td>1.</td>
      <td>System date:</td>
      <td>
        <input
          type="text"
          ng-model="\$ctrl.workingDay.systemDate"
          disabled/>
      </td>
    </tr>
    <tr>
      <td>2.</td>
      <td>Vault beginning cash amount:</td>
      <td>
        <cash ng-model="\$ctrl.counters.totalCash"
          required
          ng-disabled="true">
        </cash>
      </td>
    </tr>
    <tr>
      <td>3.</td>
      <td>Checks and other cash items amount:</td>
      <td>
        <cash ng-model="\$ctrl.counters.totalCheck"
          required
          ng-disabled="true">
        </cash>
      </td>
    </tr>
    <tr>
      <td>4.</td>
      <td>ATM beginning cash amount:</td>
      <td>
        <cash ng-model="\$ctrl.counters.totalAtmCash"
          ng-disabled="true">
        </cash>
      </td>
    </tr>
    <tr>
      <td>5.</td>
      <td>Is it a clearing day?</td>
      <td>
        <select
          ng-model="\$ctrl.clearingDay"
          boolean-options
          required>
        </select>
      </td>
    </tr>
    <tr ng-if="\$ctrl.holiday">
      <td>6.</td>
      <td>Do you have the BSP approval to operate on {{\$ctrl.holiday.name}}?</td>
      <td>
        <select
          ng-model="\$ctrl.bspApproval"
          boolean-options
          required>
        </select>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="flex-end">
    <button
      class="misc-transaction__cancel btn btn-warning"
      type="button"
      ng-click="\$ctrl.cancelChanges()">
      Cancel
    </button>
    <button
      type="submit"
      class="misc-transaction__save btn btn-success"
      ng-disabled="\$ctrl.transactionForm.\$invalid"
      ng-click="\$ctrl.save()">
      Start now
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/start-the-day/start-the-day-new.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;